/* eslint-disable import/extensions */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/lib/Modal';
import * as actions from 'actions/response';
import { GetRegion } from 'constants.js';
import Loader from 'components/Loader';
import { converter } from 'helpers/converter';
import classNames from 'classnames';
import { removeHKS } from '../../../utils/HKS';
import getFirstNode from 'utils/getFirstNode';
class ModalRetryPushSession extends React.PureComponent {
  state = {
    showLoader: false,
  };

  componentDidMount() {
    removeHKS();
  }

  handleCloseModal = () => {
    this.props.closeModal('RetryPushSession');
  };

  handleCancel = () => {
    this.props.closeModal('RetryPushSession');
    if (this.props.home) {
      const firstNode = getFirstNode();
      this.props.navigate(`/${GetRegion()}/${firstNode}`);
    }
    if (typeof this.props.onCancel === 'function') this.props.onCancel();
  };

  handleRetry = () => {
    this.props.onRetry();
  };

  render() {
    const classes = {
      fa: true,
      center: true,
      'fa-4x': true,
      'fa-check-circle': true,
    };

    const classesForBody = classNames(classes);

    return (
      <Modal show>
        <Modal.Body>
          {this.state.showLoader ? (
            <Loader />
          ) : (
            <div className="text-center">
              <i className={classesForBody} />
              <p
                className="font-size"
                style={{
                  textAlign: 'center',
                  margin: 'auto',
                  padding: '20px 0',
                }}
              >
                {this.props.message}
              </p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="form-group">
          <p className="text-center">
            <button
              className="o-button o-button--basic btn btn-lg btn-min-width"
              type="button"
              onClick={this.handleRetry}
              style={{ marginRight: '20px' }}
            >
              {converter.convertApaUnicode(
                this.props.translations,
                'btn_menu_retry',
                'Reintentar',
              )}
            </button>
            <button
              className="o-button btn btn-lg btn-min-width"
              type="button"
              onClick={this.handleCancel}
              style={{ marginLeft: '20px' }}
            >
              {converter.convertApaUnicode(
                this.props.translations,
                'cancel',
                'Cancelar',
              )}
            </button>
          </p>
        </Modal.Footer>
      </Modal>
    );
  }
}

ModalRetryPushSession.propTypes = {
  message: PropTypes.string,
  closeModal: PropTypes.func,
  onRetry: PropTypes.func,
};

const mapStateToProps = state => ({
  translations: state.translations,
});

const mapDispatchToProps = dispatch => ({
  closeModal(modalType) {
    dispatch(actions.removeModal(modalType));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ModalRetryPushSession);
